<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/affiliate/dailyStatementAffiliate")
          i.fa.fa-chart-line
          span.ml-1 {{ $t("ui.daily_statement_affiliate") }}
      b-breadcrumb-item
        router-link(to="/affiliate/settlementListAffiliate")
          i.fa.fa-file
          span.ml-1 {{ $t("ui.settlement_list_affiliate") }}
  div.row
    div.col-md-12
      div.card
        div.card-body
          div.mb-1
            div.row.mb-1
              div.col-md-10
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)").mb-1
              div.col-md-2
                b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize")
          div.row.clusterize
            div.col-md-12
              .clusterize-scroll
                table.tablex(style="width: 100%;" v-columns-resizable)
                  thead
                    tr
                      th.sticky-position(width="3%")
                        span #
                      th.sticky-position.sortable(width="9%" @click="sortOrder('account_id')")
                        span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                        i(:class="changeSortKey('account_id')")
                      th.sticky-position.sortable(width="9%" @click="sortOrder('settlement_account_id')")
                        span(:title="$t('ui.settlement_account_id')") {{ $t('ui.settlement_account_id') }}
                        i(:class="changeSortKey('settlement_account_id')")
                      th.sticky-position.sortable(width="8%" @click="sortOrder('settlement_date')")
                        span(:title="$t('ui.settlement_date')") {{ $t('ui.settlement_date') }}
                        i(:class="changeSortKey('settlement_date')")
                      th.sticky-position.sortable(width="8%" @click="sortOrder('settlement_type')")
                        span(:title="$t('ui.settlement_type')") {{ $t('ui.settlement_type') }}
                        i(:class="changeSortKey('settlement_type')")
                      th.sticky-position.sortable.text-center(width="8%" @click="sortOrder('carry_over')")
                        span(:title="$t('ui.carry_over')") {{ $t("ui.carry_over") }}
                        i(:class="changeSortKey('carry_over')")
                      th.sticky-position.sortable(width="8%" @click="sortOrder('earning_total')")
                        span(:title="$t('ui.earning_total')") {{ $t("ui.earning_total") }}
                        i(:class="changeSortKey('earning_total')")
                      th.sticky-position.sortable(width="8%" @click="sortOrder('cost_total')")
                        span(:title="$t('ui.cost_total')") {{ $t("ui.cost_total") }}
                        i(:class="changeSortKey('cost_total')")
                      th.sticky-position.sortable(width="8%" @click="sortOrder('pnl')")
                        span(:title="$t('ui.pnl')") {{ $t("ui.pnl") }}
                        i(:class="changeSortKey('pnl')")
                      th.text-center.sticky-position(width="6%")
                        span(:title="$t('ui.action')") {{ $t("ui.action") }}
                  tbody.clusterize-content
                    tr(v-if="settlementList.length == 0")
                      td(colspan="10").text-center
                        span {{ $t('message.no_data_available') }}
                    template(v-for="(item, index) in settlementList")
                      tr
                        td
                          span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                        td
                          span(:title="item.account_id") {{ item.account_id }}
                        td
                          span(:title="item.settlement_account_id") {{ item.settlement_account_id }}
                        td
                          span(:title="$moment(item.settlement_date).format('YYYY-MM-DD')") {{ $moment(item.settlement_date).format('YYYY-MM-DD') }}
                        td
                          span(:title="item.settlement_type") {{ item.settlement_type }}
                        td.text-center
                          span
                            i(:class="{'fas fa-check text-info': item.carry_over, 'fas fa-times text-warning': !item.carry_over  }")
                        td
                          span(:title="$n(item.earning_total, 'currency')") {{ $n(item.earning_total, 'currency') }}
                        td
                          span(:title="$n(item.cost_total, 'currency')") {{ $n(item.cost_total, 'currency') }}
                        td
                          span(:title="$n(item.pnl, 'currency')") {{ $n(item.pnl, 'currency') }}
                        td.text-center
                          i.fa.ml-1(:title="$t('ui.detail')" size="sm" @click="onOffDetail(item)" :class="(IsOpenRow(item) == true)? 'fa-eye-slash text-danger' : 'fa-eye text-success'" style="cursor: pointer;")
                      tr(v-if="isShowDetail == true && IsOpenRow(item) == true")
                        td(colspan="10")
                          table.tablex(style="width: 100%;").mb-2
                            thead
                              tr
                                th.sticky-position(width="12%")
                                  span(:title="$t('ui.deposit_bonus')") {{ $t("ui.deposit_bonus") }}
                                th.sticky-position(width="12%")
                                  span(:title="$t('ui.wl_sports')") {{ $t("ui.wl_sports") }}
                                th.sticky-position(width="12%")
                                  span(:title="$t('ui.wl_slots')") {{ $t("ui.wl_slots") }}
                                th.sticky-position(width="12%")
                                  span(:title="$t('ui.wl_livecasino')") {{ $t("ui.wl_livecasino") }}
                                th.sticky-position(width="12%")
                                  span(:title="$t('ui.to_cockfight')") {{ $t("ui.to_cockfight") }}
                                th.sticky-position(width="12%")
                                  span(:title="$t('ui.wl_others')") {{ $t("ui.wl_others") }}
                            tbody.clusterize-content
                              tr
                                td
                                  span(:title="$n(item.deposit_bonus, 'currency')") {{ $n(item.deposit_bonus, 'currency') }}
                                td
                                  span(:title="$n(item.wl_sports, 'currency')") {{ $n(item.wl_sports, 'currency') }}
                                td
                                  span(:title="$n(item.wl_slots, 'currency')") {{ $n(item.wl_slots, 'currency') }}
                                td
                                  span(:title="$n(item.wl_livecasino, 'currency')") {{ $n(item.wl_livecasino, 'currency') }}
                                td
                                  span(:title="$n(item.to_cockfight, 'currency')") {{ $n(item.to_cockfight, 'currency') }}
                                td
                                  span(:title="$n(item.wl_others, 'currency')") {{ $n(item.wl_others, 'currency') }}
                          table.tablex(style="width: 100%;").mb-2
                            thead
                              tr
                                th.sticky-position(width="12%")
                                  span(:title="$t('ui.pct_platform')") {{ $t("ui.pct_platform") }}
                                th.sticky-position(width="12%")
                                  span(:title="$t('ui.pct_sports')") {{ $t("ui.pct_sports") }}
                                th.sticky-position(width="12%")
                                  span(:title="$t('ui.pct_slots')") {{ $t("ui.pct_slots") }}
                                th.sticky-position(width="12%")
                                  span(:title="$t('ui.pct_livecasino')") {{ $t("ui.pct_livecasino") }}
                                th.sticky-position(width="12%")
                                  span(:title="$t('ui.pct_cockfight')") {{ $t("ui.pct_cockfight") }}
                                th.sticky-position(width="12%")
                                  span(:title="$t('ui.pct_others')") {{ $t("ui.pct_others") }}
                            tbody.clusterize-content
                              tr
                                td
                                  span(:title="$n(item.pct_platform, 'currency')") {{ $n(item.pct_platform, 'currency') }}
                                td
                                  span(:title="$n(item.pct_sports, 'currency')") {{ $n(item.pct_sports, 'currency') }}
                                td
                                  span(:title="$n(item.pct_slots, 'currency')") {{ $n(item.pct_slots, 'currency') }}
                                td
                                  span(:title="$n(item.pct_livecasino, 'currency')") {{ $n(item.pct_livecasino, 'currency') }}
                                td
                                  span(:title="$n(item.pct_cockfight, 'currency')") {{ $n(item.pct_cockfight, 'currency') }}
                                td
                                  span(:title="$n(item.pct_others, 'currency')") {{ $n(item.pct_others, 'currency') }}
                          table.tablex(style="width: 100%;").mb-2
                            thead
                              tr
                                th.sticky-position(width="12%")
                                  span(:title="$t('ui.earning_sports')") {{ $t("ui.earning_sports") }}
                                th.sticky-position(width="12%")
                                  span(:title="$t('ui.earning_slots')") {{ $t("ui.earning_slots") }}
                                th.sticky-position(width="12%")
                                  span(:title="$t('ui.earning_livecasino')") {{ $t("ui.earning_livecasino") }}
                                th.sticky-position(width="12%")
                                  span(:title="$t('ui.earning_cockfight')") {{ $t("ui.earning_cockfight") }}
                                th.sticky-position(width="12%")
                                  span(:title="$t('ui.earning_others')") {{ $t("ui.earning_others") }}
                            tbody.clusterize-content
                              tr
                                td
                                  span(:title="$n(item.earning_sports, 'currency')") {{ $n(item.earning_sports, 'currency') }}
                                td
                                  span(:title="$n(item.earning_slots, 'currency')") {{ $n(item.earning_slots, 'currency') }}
                                td
                                  span(:title="$n(item.earning_livecasino, 'currency')") {{ $n(item.earning_livecasino, 'currency') }}
                                td
                                  span(:title="$n(item.earning_cockfight, 'currency')") {{ $n(item.earning_cockfight, 'currency') }}
                                td
                                  span(:title="$n(item.earning_others, 'currency')") {{ $n(item.earning_others, 'currency') }}
                          table.tablex(style="width: 100%;").mb-2
                            thead
                              tr
                                th.sticky-position(width="12%")
                                  span(:title="$t('ui.cost_deposit_bonus')") {{ $t("ui.cost_deposit_bonus") }}
                                th.sticky-position(width="12%")
                                  span(:title="$t('ui.cost_sports')") {{ $t("ui.cost_sports") }}
                                th.sticky-position(width="12%")
                                  span(:title="$t('ui.cost_slots')") {{ $t("ui.cost_slots") }}
                                th.sticky-position(width="12%")
                                  span(:title="$t('ui.cost_livecasino')") {{ $t("ui.cost_livecasino") }}
                                th.sticky-position(width="12%")
                                  span(:title="$t('ui.cost_cockfight')") {{ $t("ui.cost_cockfight") }}
                                th.sticky-position(width="12%")
                                  span(:title="$t('ui.cost_others')") {{ $t("ui.cost_others") }}
                            tbody.clusterize-content
                              tr
                                td
                                  span(:title="$n(item.cost_deposit_bonus, 'currency')") {{ $n(item.cost_deposit_bonus, 'currency') }}
                                td
                                  span(:title="$n(item.cost_sports, 'currency')") {{ $n(item.cost_sports, 'currency') }}
                                td
                                  span(:title="$n(item.cost_slots, 'currency')") {{ $n(item.cost_slots, 'currency') }}
                                td
                                  span(:title="$n(item.cost_livecasino, 'currency')") {{ $n(item.cost_livecasino, 'currency') }}
                                td
                                  span(:title="$n(item.cost_cockfight, 'currency')") {{ $n(item.cost_cockfight, 'currency') }}
                                td
                                  span(:title="$n(item.cost_others, 'currency')") {{ $n(item.cost_others, 'currency') }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css';

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker
  },
  data: () => ({
    loading: false,
    settlementList: [],
    currentPage: 1,
    totalRow: 0,
    source: "",
    target: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    dateRange: {
      startDate: null,
      endDate: null
    },
    sortKey: "account_id",
    sortType: "asc",
    sourceId: null,
    targetId: null,
    settleDate: null,
    isShowDetail: false,
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    isAdmin() {
      return this.$store.getters.accountId == config.superUser;
    },
  },
  mounted: function() {
    if (this.$store.getters.settlementListAff.account_id != null)
      this.source = this.$store.getters.settlementListAff.account_id;

    if (this.$store.getters.settlementListAff.start_date && this.$store.getters.settlementListAff.end_date) {
      this.start_date = this.$store.getters.settlementListAff.start_date;
      this.end_date = this.$store.getters.settlementListAff.end_date;
    } else {
      this.start_date = this.$moment(new Date).format('YYYY-MM-DD');
      this.end_date = this.$moment(new Date).format('YYYY-MM-DD');
    }

    this.getSettlementList(true);
  },
  methods: {
    IsOpenRow(item) {
      return (this.sourceId == item.account_id &&
              this.targetId == item.settlement_account_id &&
              this.settleDate == item.settlement_date)
    },
    onOffDetail(item) {
      if (this.isShowDetail == true) {
        if (this.sourceId == item.account_id) {
          this.isShowDetail = false;
          this.sourceId = null;
          this.targetId = null;
          this.settleDate = null;
        } else {
          this.isShowDetail = false;
          this.sourceId = null;
          this.targetId = null;
          this.settleDate = null;
          this.isShowDetail = true;
          this.sourceId = item.account_id;
          this.targetId = item.settlement_account_id;
          this.settleDate = item.settlement_date;
        }
      } else {
        this.isShowDetail = true;
        this.sourceId = item.account_id;
        this.targetId = item.settlement_account_id;
        this.settleDate = item.settlement_date;
      }
    },
    sortOrder(key, type) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }
      this.getSettlementList(true);
    },
    changeSortKey(key, type) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    getSettlementList: function(isSearch) {
      let url = config.settlementListAffUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        start_date: this.start_date,
        end_date: this.end_date,
        account_id: this.source,
        settlement_account_id: this.target,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.settlementList = response.data.dt;
                this.totalRow = this.settlementList.length > 0 ? this.settlementList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getSettlementList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getSettlementList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>